import React from 'react';

import { SidePage } from '@gogame/components';

export const SidePageCloseButton = ({ label = 'Save' }) => {
  return <SidePage.CloseButton label={'Cancel'}>{label}</SidePage.CloseButton>;
};
